import { API_URL } from "../config/connect";

// userType кілті бойынша кэш: әр түрлі пайдаланушылар үшін бэкенд әртүрлі
// тариф тізімін қайтарғысы келеді ('individual' / 'dealer'). Параметрсіз шақыру
// бүкіл тізімді қайтарады (алдыңғы әрекетпен үйлесімді).
const cache = new Map();

/**
 * Fetches tariffs from the backend, optionally filtered by user type.
 * Cached per userType for the session — subsequent callers share one
 * in-flight request and get the resolved result instantly. Cache for the
 * given key resets only on failure so a retry is possible.
 * @param {string} [userType] - 'individual' | 'dealer'; when omitted, all tariffs are returned.
 * @returns {Promise<Array>} Array of tariffs with features
 */
export async function getTariffs(userType) {
    const key = userType || 'all';
    if (cache.has(key)) return cache.get(key);

    const endpoint = `${API_URL}/api/v1/tariffs${userType ? `?user_type=${encodeURIComponent(userType)}` : ''}`;

    const promise = (async () => {
        const accessToken = localStorage.getItem("access_token");
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...(accessToken ? { 'Authorization': `Bearer ${accessToken}` } : {}),
            },
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ detail: response.statusText }));
            throw new Error(`Error: ${response.status} - ${errorData.detail || response.statusText}`);
        }

        const data = await response.json();
        return data.tariffs || [];
    })().catch((error) => {
        console.error('Failed to get tariffs:', error);
        cache.delete(key);
        throw error;
    });

    cache.set(key, promise);
    return promise;
}